import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private auth: ApiService, private _router: Router) { }
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const jwtToken = localStorage.getItem('jwtToken');
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');

    if (jwtToken && currentUser) {
      return true;
    } else {
      const lang = route.queryParams['lang'];
      this._router.navigate([''], {
        queryParams: lang ? { lang } : {}
      });
      return false;
    }
  }
}

